import React, { Component } from 'react';
import { translate } from 'react-i18next';
import swal from 'sweetalert';

var Config = require('../../config');

class DonationData extends Component{

    constructor(props, context) {
		super(props, context);

        this.state = {
            convoke_places:[],
            extraction_types:[]
		};
	}

    componentDidMount(){
		console.log(this.props);
        fetch(Config.default.apiGateway.URL+'convoke_places?option=operatives&health_facilities_id='+sessionStorage.getItem("health_facilities_id"),{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			this.setState({
		      convoke_places: response
		    });
		})

        fetch(Config.default.apiGateway.URL+'donation_type_extraction',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', "Tipos Extracción: "+result, 'error');
	          });
        }})
		.then(response => {
			this.setState({
		      extraction_types: response
		    });
		})
    }

    render(){
        const { t } = this.props;
        return(
            <div className="col-xs-12" style={{padding:"0px"}}>
                {this.props.showField("offer", "date")?
                    <div className="col-xs-12 col-sm-2" >
                        <span className="span-min">Fecha Cita</span>
                        <input className="form-control hour-input" type="date" name="timestamp_date" id="timestamp_date"
                            value={ this.props.state.timestamp_date } disabled required/>
                    </div>
                :null}

                {this.props.showField("offer", "hour")?
                    <div className="col-xs-12 col-sm-1">
                        <span className="span-min">Hora Cita</span>
                        <input id="timestamp_hour" name="timestamp_hour" type="text" data-inputmask-alias="datetime" 
                            data-inputmask-inputformat="HH:MM"  data-inputmask-placeholder="-" 
                            value={this.props.state.timestamp_hour || ""} 
                            className="form-control"  disabled required/>
                    </div>
                :null}

                {this.props.showField("offer", "CONVOKE_PLACE")?
                    <div className="col-xs-12 col-sm-3">
                        <span className="span-min">{t('content.offers.form.convoke_place')}</span>
                        <select className="form-control"
                            value={ this.props.state.convoke_places_id || "" } onKeyPress={(e) => this.props.validate(e)}
                            onChange={ this.props.selectFieldHandle.bind(null,"id","convoke_places_id") } autoFocus={true}
                            name="convoke_places_id" id="convoke_places_id" >
                                <option value="">Seleccionar...</option>
                            {
                            this.state.convoke_places.map(function(t) {
                                return <option key={t.convoke_places.id}  value={t.convoke_places.id} >{t.convoke_places.name} </option>;
                            })
                        }
                        </select>
                    </div>	
                :null}			        

                {this.props.showField("offer", "extraction_type")?
                    <div className="col-xs-12 col-sm-2">
                        <span className="span-min">{t('content.offers.form.extraction_type')}</span>
                        <select className="form-control" onKeyPress={(e) => this.props.validate(e)}
                            value={ this.props.state.donation_type_extraction_id || ""} 
                            onChange={ this.props.extractionTypeSelected.bind(null,"id","donation_type_extraction_id") }
                            name="donation_type_extraction_id"id="donation_type_extraction_id">
                            <option value="" disabled>Seleccionar...</option>
                            {
                            this.state.extraction_types.map(function(t) {
                                return <option key={t.donation_type_extraction.id} value={t.donation_type_extraction.id} >{t.lookup_value}</option>;
                            })
                        }
                        </select>
                    </div>
                :null}

                {this.props.showField("offer", "donation_type")?
                    <div className="col-xs-12 col-sm-2">
                        <span className="span-min">{t('content.offers.form.donation_type')}</span>
                        <select className="form-control" name="donation_type_id" id="donation_type_id" 
                            value={ this.props.state.donation_type_id || ""} onKeyPress={(e) => this.props.validate(e)}
                            onChange={ this.props.donationTypeSelected.bind(null,"id","donation_type_id") }>
                            <option value="" disabled >Seleccionar...</option>
                            {
                            this.props.state.donation_types.map(function(t) {
                                return <option key={t.donation_type.id} value={t.donation_type.id} >{t.donation_type_lookup}</option>;
                            })
                        }
                        </select>
                    </div>
                :null}
            </div>
        );
    }
}

export default translate('translations')(DonationData);